import { useEffect, useRef, useState } from 'react';
import styles from './PodErrorDrawer.module.scss';

interface Props {
  show: boolean,
  text: string,
  className?: string,
}

const PodErrorDrawer = ({show, text, className}: Props) => {
  const [deferredText, setDeferredText] = useState(text);
  
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  /**
   * Ensure that if the show boolean references the same variable as the text content,
   * the latter updates on a delay. Thus, setting an empty string will start the
   * slide-up animation and the update timeout, the animation will run to completion,
   * and then the text will be removed from the DOM.
   */
  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (show === true) {
      setDeferredText(text);
    } else {
      const timeout = setTimeout(() => {
        setDeferredText(text);
        timeoutRef.current = undefined;
      }, 250);

      timeoutRef.current = timeout;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, text]);

  return (
    <div className={`${styles.errorDrawer}${show ? ` ${styles.show}` : ''}${className ? ` ${className}` : ''}`}>
      <div className={styles.error}>
        {deferredText}
      </div>
    </div>
  );
};

export default PodErrorDrawer;